export const getOneTimeQuotes = (quotes = []) => (
    quotes.filter(quote => Number(quote.is_subscription) !== 1)
);

const CADENCE_TO_QUOTE_TYPE = {
    monthly: 'mensual',
    quarterly: 'trimestral',
    semiannual: 'semestral',
    annual: 'anual',
};

const ONE_TIME_QUOTE_TYPES = new Set([
    'anual',
    'semestral',
    'quadrimestral',
    'trimestral',
]);

export const getQuoteTypeForBillingMode = ({
    isSubscription = false,
    cadence = 'monthly',
    currentType,
} = {}) => {
    if (isSubscription) {
        return CADENCE_TO_QUOTE_TYPE[cadence] || 'mensual';
    }

    return ONE_TIME_QUOTE_TYPES.has(currentType) ? currentType : 'anual';
};
